import classNames from 'classnames'
import React from 'react'
import {getGroupedInvoiceItems} from '../../../../../../../../commons/selectors/order'
import {getTicketsWithoutTax} from '../../../../../../../../commons/selectors/tickets'
import c from '../../../../classnames.scss'
import {InvoiceBreakdown} from '../../../../invoice-breakdown'
import {InvoiceProps} from './interfaces'
import s from './invoice.scss'
import {PlaceInfo} from './place-info'
import {TicketInfo} from './ticket-info'

export const Invoice = ({orderHasSeats, order}: InvoiceProps) => (
  <div className={classNames(c.textFont, c.formLabelsColor)}>
    {orderHasSeats
      ? getTicketsWithoutTax(order).map((ticket, index) => <PlaceInfo key={index} ticket={ticket} />)
      : getGroupedInvoiceItems(order).map((item, index) => <TicketInfo key={index} item={item} />)}
    <InvoiceBreakdown containerClass={s.container} />
  </div>
)
